import React from 'react';

/**
 * A translated sentence with its {{vars}} drawn bold, so the numbers in it keep
 * their emphasis in every language without splitting the sentence into
 * per-word keys. Pass the template as t(key) without vars: t() leaves the
 * placeholders in place then. `styles` optionally maps a var name to an
 * inline style for its <b>.
 */
export default function boldVars(template, vars = {}, styles = {}) {
  return String(template || '').split(/(\{\{\w+\}\})/).map((part, i) => {
    const m = part.match(/^\{\{(\w+)\}\}$/);
    if (!m) return part ? <React.Fragment key={i}>{part}</React.Fragment> : null;
    return <b key={i} style={styles[m[1]]}>{vars[m[1]] ?? ''}</b>;
  });
}
